import {Injectable} from '@angular/core';
import {Chart} from "chart.js/auto";
import {PercentUiVo} from '../models/percent-ui-vo';


@Injectable()
export class PercentUiControllerService {
  datasets: PercentUiVo[] = []

  setDataset(dataset: PercentUiVo[]) {
    this.datasets = [...dataset];
  }

  buildDatasetFromChartData(chart: Chart<"doughnut", any, any>) {
    let dataset = chart.data.datasets[0].data.map((x: number, i: number) => {
      return {
        name: chart.data.labels![i],
        index: i,
        percent: x,
        revenue: chart.data.datasets[0].data[i],
        isActive: !chart?.legend?.legendItems![i].hidden,
      };
    });




    let total = this.getTotalRevenue(dataset);
    if (total > 0) {
      dataset.forEach((x: PercentUiVo) => (x.percent = (x.percent / total) * 100));
    }

    let altTotal: number | undefined = undefined;
    if (total === 0) {
      altTotal = this.getOnlyPositiveRevenue(dataset) as number;
      if (altTotal > 0) {
        dataset.forEach((x: PercentUiVo) => (x.percent = (x.revenue / altTotal!) * 100));
      }
      if (altTotal === 0) {
        alert("Problem");
        // todo shouldn't happen -> error
        dataset.forEach((x: PercentUiVo) => (x.percent = 0));
      }
    }



    this.setDataset(dataset);
  }

  getTotalRevenue(data: PercentUiVo[]) {
    return data.reduce((acc: number, x: PercentUiVo) => acc + (x.isActive ? x.revenue : 0), 0);
  }

  getOnlyPositiveRevenue(data: PercentUiVo[]) {
    return data.reduce((acc: number, x: PercentUiVo) => acc + (x.isActive && x.revenue > 0 ? x.revenue : 0), 0);
  }
}
